import auth0 from 'auth0-js'

const auth0WebAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: `${window.origin}/log-in`,
})

export default auth0WebAuth
